import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Form from './usuarioForm';
import Aguardando from '../common/template/aguardando';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    alterarsenha,
    getLista
} from './usuarioActions';

import {
    getLista as getListaPerfil
} from '../usuarioPerfil/usuarioPerfilActions';

const columns = [
    {
        field: 'nome',
        type: 'text'
    },
    {
        field: 'email',
        type: 'text'
    },
    {
        field: 'nomes_perfis',
        type: 'text'
    }
];

const Usuario = props => {

    const [linhaSelecionada, setLinhaSelecionada] = useState(null);
    const [pesquisar, setPesquisar] = useState('');
    const [sort, setSort] = useState({
        field: 'nome',
        direction: 'asc'
    });

    useEffect(() => {
        props.getLista();
        props.getListaPerfil();
    }, []);

    const onSort = field => {
        setSort(prev => {
            let direction = 'asc';

            if (prev.field === field) {
                direction = prev.direction === 'asc' ? 'desc' : 'asc';
            }

            return {
                field,
                direction
            };
        });
    };

    const filtrar = () => {
        const termoPesquisa = (pesquisar || '').trim();

        const listaFiltrada = (props.lista || []).filter(item => {
            if (!termoPesquisa) {
                return true;
            }

            const texto = `
                ${item.nome || ''}
                ${item.email || ''}
                ${item.nomes_perfis || ''}
            `.toUpperCase();

            return termoPesquisa
                .toUpperCase()
                .split('+')
                .filter(p => p.trim())
                .every(p => texto.includes(p.trim()));
        });

        return sortData(listaFiltrada, sort, columns);
    };

    const montarExcel = lista => {
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        return (
            <ExcelSheet
                data={lista}
                name='Usuários'
            >
                <ExcelColumn label='Nome' value='nome' />
                <ExcelColumn label='E-mail' value='email' />
                <ExcelColumn label='Perfis de Acesso' value='nomes_perfis' />
            </ExcelSheet>
        );
    };

    const renderLista = () => {
        const ExcelFile = ReactExport.ExcelFile;
        const lista = filtrar();

        const alturaTabela = window.innerWidth < 631
            ? window.innerHeight - 260
            : window.innerHeight - 180;

        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={value => setPesquisar(value)}
                        />

                        <div>
                            <button
                                type='button'
                                className='btn btn-app bg-success'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => {
                                    props.setModoTela('cadastro', {});
                                    props.initForm({});
                                }}
                            >
                                <i className='fas fa-plus'></i> Adicionar
                            </button>

                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => props.getLista()}
                            >
                                <i className='fas fa-sync-alt'></i> Atualizar
                            </button>

                            <ExcelFile
                                filename='Usuários'
                                element={
                                    <button
                                        type='button'
                                        className='btn btn-app bg-info'
                                        style={{ marginLeft: 2, minWidth: 75 }}
                                    >
                                        <i className='fas fa-file-excel'></i> Exportar
                                    </button>
                                }
                            >
                                {montarExcel(lista)}
                            </ExcelFile>
                        </div>
                    </Row>
                </ContentCardHeader>

                <ContentCardBody>
                    <Table
                        responsive
                        border
                        alturaFixa
                        striped
                        maxHeight={alturaTabela}
                    >
                        <THead>
                            <Tr>
                                <ThSort
                                    field='nome'
                                    label='Nome'
                                    width={250}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='email'
                                    label='E-mail'
                                    width={250}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='nomes_perfis'
                                    label='Perfis de Acesso'
                                    width={300}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <Th sticky alignCenter width={50}></Th>
                            </Tr>
                        </THead>

                        <TBody>
                            {lista.map((item, i) => (
                                <Tr
                                    key={item.id}
                                    backgroundColor={
                                        linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : i % 2 === 0
                                                ? '#ffffff'
                                                : '#f5f5f5'
                                    }
                                >
                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
										alignCenter
                                    >
                                        {item.nome}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.email}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.nomes_perfis}
                                    </Td>

                                    <Td alignCenter minWidth={165} maxWidth={165}>
                                        <ButtonTable
                                            type='primary'
                                            width={32}
                                            small
                                            icon='fas fa-pencil-alt'
                                            visible
                                            title='Editar'
                                            event={() => {
                                                props.setModoTela('cadastroConf', {
                                                    ...item,
                                                    senha: null
                                                });

                                                props.initForm({
                                                    ...item,
                                                    senha: null
                                                });
                                            }}
                                        />

                                        <ButtonTable
                                            type='warning'
                                            width={32}
                                            small
                                            icon='fas fa-lock'
                                            visible
                                            title='Alterar senha'
                                            event={() => {
                                                props.setModoTela('alterarsenha', {
                                                    ...item,
                                                    senha: null
                                                });

                                                props.initForm({
                                                    ...item,
                                                    senha: null
                                                });
                                            }}
                                        />

                                        <ButtonTable
                                            type='danger'
                                            width={32}
                                            small
                                            icon='fas fa-trash-alt'
                                            visible
                                            title='Excluir'
                                            event={() => {
                                                props.setModoTela('exclusao', {
                                                    ...item,
                                                    senha: null
                                                });

                                                props.initForm({
                                                    ...item,
                                                    senha: null
                                                });
                                            }}
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    };

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modoTela === 'cadastro' &&
                <Form onSubmit={props.salvar} />}

            {props.modoTela === 'alterarsenha' &&
                <Form onSubmit={props.alterarsenha} />}

            {props.modoTela === 'cadastroConf' &&
                <Form configuracao onSubmit={props.salvar} />}

            {props.modoTela === 'exclusao' &&
                <Form excluir onSubmit={props.excluir} />}

            {props.modoTela === 'lista' &&
                renderLista()}
        </Content>
    );
};

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.usuario.modoTela,
    aguardando: state.usuario.aguardando,
    lista: state.usuario.lista,
    listaPerfil: state.usuarioPerfil.listaSelect
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    salvar,
    excluir,
    alterarsenha,
    getLista,
    getListaPerfil
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Usuario);